<template>
  <section class="c-user-documents">
    <card class="data-card" :show-footer-line="true">
      <b-row no-gutters>
        <b-col class="">
          <h1 class="card-header p-0 card-header-text pb-3">مدارک شناسایی</h1>
        </b-col>
      </b-row>
      <b-row class="row-form pt-5 text-center" align-h="between">
        <b-col sm="5">
          <div>
            <h3>
              {{ docs.identityCard.name }}
            </h3>
            <b-skeleton-img
              v-if="docs.identityCard.loading"
              no-aspect
              height="250px"
            />

            <template v-else-if="docs.identityCard.empty">
              <b-jumbotron
                style="margin-bottom: 0; height: 250px; padding: 5px"
              >
                <a target="_blank">
                  <div class="image-error-container">
                    <i class="fa fa-close-circle fa-5x"></i>
                    <span> مدرکی از طرف کاربر ارسال نشده است. </span>
                  </div>
                </a>
              </b-jumbotron>
            </template>

            <template v-else>
              <template v-if="docs.identityCard.status === 'InReview'">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div
                      v-if="!docs.identityCard.file"
                      class="image-error-container"
                    >
                      <i class="fa fa-info-circle fa-5x"></i>
                      <span> تصویر بارگزاری نشد. </span>
                    </div>
                    <img
                      v-else
                      @click="previewDocImage(docs.identityCard.file)"
                      style="height: 100%; max-width: 100%"
                      :src="docs.identityCard.file"
                      alt=""
                    />
                  </a>
                </b-jumbotron>

              </template>
              <template v-else-if="docs.identityCard.isApproved">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div class="image-error-container">
                      <i class="fa fa-check-circle fa-5x text-success"></i>
                      <span> تصویر تایید شده است. </span>
                    </div>
                  </a>
                </b-jumbotron>
              </template>
              <template v-else-if="docs.identityCard.isRejected">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div class="image-error-container">
                      <i class="fa fa-close-circle text-danger fa-5x"></i>
                      <span> تصویر کاربر رد شده است. </span>
                    </div>
                  </a>
                </b-jumbotron>
              </template>

              <div class="mt-3">
                <base-button
                  v-if="adminsAccessOnly"
                  @click="docs.identityCard.rejectDoc"
                  :loading="reject.loading"
                  class="ml-2"
                  type="danger"
                >
                  رد مدرک
                </base-button>
                <base-button
                  v-if="!docs.identityCard.isApproved && adminsAccessOnly"
                  @click="docs.identityCard.approveDoc"
                  :loading="approve.loading"
                  type="success"
                >
                  تایید مدرک
                </base-button>
              </div>
            </template>

            <base-button
              :loading="docs.identityCard.uploadLoading"
              class="mt-3"
              v-if="docs.identityCard.empty && adminsAccessOnly"
              type="primary"
            >
              <input
                @change="uploadDocument(docs.identityCard,$event.target,'IdentityDocument')"
                type="file" class="input-file">
              اپلود مدرک
            </base-button>
          </div>
        </b-col>

        <b-col sm="5">
          <div>
            <h3>
              {{ docs.selfie.name }}
            </h3>
            <b-skeleton-img
              v-if="docs.selfie.loading"
              no-aspect
              height="250px"
            />

            <template v-else-if="docs.selfie.empty">
              <b-jumbotron
                style="margin-bottom: 0; height: 250px; padding: 5px"
              >
                <a target="_blank">
                  <div class="image-error-container">
                    <i class="fa fa-close-circle fa-5x"></i>
                    <span> مدرکی از طرف کاربر ارسال نشده است. </span>
                  </div>
                </a>
              </b-jumbotron>
            </template>

            <template v-else>
              <template v-if="docs.selfie.status === 'InReview'">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div v-if="!docs.selfie.file" class="image-error-container">
                      <i class="fa fa-info-circle fa-5x"></i>
                      <span> تصویر بارگزاری نشد. </span>
                    </div>
                    <img
                      v-else
                      @click="previewDocImage(docs.selfie.file)"
                      style="height: 100%; max-width: 100%"
                      :src="docs.selfie.file"
                      alt=""
                    />
                  </a>
                </b-jumbotron>
              </template>
              <template v-else-if="docs.selfie.isApproved">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div class="image-error-container">
                      <i class="fa fa-check-circle fa-5x text-success"></i>
                      <span> تصویر تایید شده است. </span>
                    </div>
                  </a>
                </b-jumbotron>
              </template>
              <template v-else-if="docs.selfie.isRejected">
                <b-jumbotron
                  style="margin-bottom: 0; height: 250px; padding: 5px"
                >
                  <a target="_blank">
                    <div class="image-error-container">
                      <i class="fa fa-close-circle text-danger fa-5x"></i>
                      <span> تصویر کاربر رد شده است. </span>
                    </div>
                  </a>
                </b-jumbotron>
              </template>
              <div class="mt-3">
                <base-button
                  v-if="adminsAccessOnly"
                  @click="docs.selfie.rejectDoc"
                  :loading="reject.loading"
                  class="ml-2"
                  type="danger"
                >
                  رد مدرک
                </base-button>

                <base-button
                  v-if="!docs.selfie.isApproved && adminsAccessOnly"
                  @click="docs.selfie.approveDoc"
                  :loading="approve.loading"
                  type="success"
                >
                  تایید مدرک
                </base-button>


              </div>
            </template>

            <base-button
              :loading="docs.selfie.uploadLoading"
              class="mt-3"
              v-if="docs.selfie.empty && adminsAccessOnly"
              type="primary"
            >
              <input
                @change="uploadDocument(docs.selfie,$event.target,'Selfie')"
                type="file" class="input-file">
              اپلود مدرک
            </base-button>
          </div>
        </b-col>
      </b-row>
    </card>

    <b-modal :hide-footer="true" size="lg" id="image-preview">
      <img style="max-width: 100%" :src="docFileToPreview" alt=""/>
    </b-modal>
  </section>
</template>

<script>
import {downloadDoc, getDocs, uploadDoc, verifyDoc} from "@/httpservices/Document";
import Swal from "sweetalert2";
import store from "@/store";

export default {
  name: "user-documents",

  data() {
    return {
      docs: {
        loading: true,
        selfie: {
          name: "عکس سلفی",
          file: null,
          status: null,
          loading: true,
          uploadLoading: false,
          empty: true,
          isRejected: false,
          isApproved: false,
        },
        identityCard: {
          name: "کارت ملی",
          file: null,
          status: null,
          loading: true,
          uploadLoading: false,
          empty: true,
          isRejected: false,
          isApproved: false,
        },
      },
      docFileToPreview: null,
      approve: {
        loading: false,
        index: "",
      },
      reject: {
        loading: false,
        index: "",
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.getDocuments();
    });
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin'] || store.getters['isApprovingManager']);
    }
  },


  methods: {
    async getDocuments() {
      this.docs.loading = true;
      try {
        const res = (await getDocs(this.$route.params.id)).data || [];
        const selfie =
          Object.values(res)
            .filter((i) => i.type === "Selfie")
            .reverse()
            .shift() || {};
        const identityCard =
          Object.values(res)
            .filter((i) => i.type === "IdentityDocument")
            .reverse()
            .shift() || {};

        const downloadFile = async (docId) => {
          if (!docId) return;
          try {
            return (
              "data:image/jpeg;base64," +
              (await downloadDoc(this.$route.params.id, docId)).data.content
            );
          } catch (e) {
            console.log({e});
          }
        };

        this.docs.selfie = {
          ...this.docs.selfie,
          file: selfie.status === "InReview" && (await downloadFile(selfie.id)),
          status: selfie.status,
          loading: false,
          uploadLoading: false,
          empty: !Boolean(selfie.id),
          isRejected: selfie.status === "Rejected",
          isApproved: selfie.status === "Approved",
          approveDoc: async () => {
            const {isConfirmed} = await Swal.fire({
              title: "توجه",
              html: "<div class='mb-2 mt-2'>آیا از تایید کردن این مدرک مطمئن هستید ؟</div>",
              showDenyButton: true,
              confirmButtonText: "بله",
              denyButtonText: `خیر`,
            });
            if (!isConfirmed) return;
            this.approve.loading = true;
            await this.verifyDocument(selfie, true);
            this.approve.loading = false;
            this.$bvModal.hide("approve-modal-doc");
          },
          rejectDoc: async () => {
            const {isConfirmed} = await Swal.fire({
              title: "توجه",
              html: "<div class='mb-2 mt-2'>آیا از رد کردن این مدرک مطمئن هستید ؟</div>",
              showDenyButton: true,
              confirmButtonText: "بله",
              denyButtonText: `خیر`,
            });
            if (!isConfirmed) return;
            this.reject.loading = true;
            await this.verifyDocument(selfie, false);
            this.reject.loading = false;
            this.$bvModal.hide("reject-modal-doc");
          },
        };
        this.docs.identityCard = {
          ...this.docs.identityCard,
          file: await downloadFile(identityCard.id),
          status: identityCard.status,
          loading: false,
          uploadLoading: false,
          empty: !Boolean(identityCard.id),
          isRejected: identityCard.status === "Rejected",
          isApproved: identityCard.status === "Approved",
          approveDoc: async () => {
            const {isConfirmed} = await Swal.fire({
              title: "توجه",
              html: "<div class='mb-2 mt-2'>آیا از تایید کردن این مدرک مطمئن هستید ؟</div>",
              showDenyButton: true,
              confirmButtonText: "بله",
              denyButtonText: `خیر`,
            });
            if (!isConfirmed) return;
            this.approve.loading = true;
            await this.verifyDocument(identityCard, true);
            this.approve.loading = false;
            this.$bvModal.hide("approve-modal-doc");
          },
          rejectDoc: async () => {
            const {isConfirmed} = await Swal.fire({
              title: "توجه",
              html: "<div class='mb-2 mt-2'>آیا از رد کردن این مدرک مطمئن هستید ؟</div>",
              showDenyButton: true,
              confirmButtonText: "بله",
              denyButtonText: `خیر`,
            });
            if (!isConfirmed) return;
            this.reject.loading = true;
            await this.verifyDocument(identityCard, false);
            this.reject.loading = false;
            this.$bvModal.hide("reject-modal-doc");
          },
        };
      } catch (e) {
        console.log({e});
      }

      this.docs.loading = false;
    },

    async verifyDocument(doc, status) {
      doc.loading = true;
      try {
        await verifyDoc(this.$route.params.id, doc.id, status);
        await Swal.fire({
          title: "توجه!",
          icon: "success",
          html: "با موفقیت انجام شد.",
        });
        await this.getDocuments();
      } catch (e) {
        console.log({e});
      }
      doc.loading = false;
    },

    previewDocImage(file) {
      this.docFileToPreview = file;
      this.$bvModal.show("image-preview");
    },

    async uploadDocument(doc, input, type) {

      const [file] = input.files;
      if (file) {
        try {
          doc.uploadLoading = true;
          await uploadDoc(this.$route.params.id, file, type);
          await this.getDocuments();
          await Swal.fire({
            title: "توجه!",
            icon: "success",
            html: "با موفقیت اپلود شد.",
          });
        } catch (e) {
          console.log({e})
        }
        doc.uploadLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">

.input-file {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9;
  opacity: 0;
  cursor: pointer;
}


.c-user-documents {
  text-align: center;
}

.image-error-container {
  display: flex;
  align-content: center;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
</style>
